<script setup lang="ts">
import { Form } from 'vee-validate'
import { ref } from 'vue'

const { validationSchema, initialValues } = defineProps({
  validationSchema: { type: Object, default: () => ({}) },
  initialValues: { type: Object, default: () => ({}) },
})

const emit = defineEmits(['submit'])

const formRef = ref()

const setValues = (values: Record<string, any>) => {
  formRef.value?.setValues(values)
}

defineExpose({
  setValues,
})

const onSubmitClick = (args: any) => {
  emit('submit', args)
}
</script>

<template>
    <Form ref="formRef" :validation-schema="validationSchema" :initial-values="initialValues" @submit="onSubmitClick">
        <slot />
    </Form>
</template>
